import Tick from "@/svgs/tick.svg";

const ProgressBar = ({ percentage }: { percentage: number }) => {
	const finished = percentage === 100;
	return (
		<div className="flex items-center">
			<div className="bg-charcoal-light w-full rounded-l-full">
				<div
					className="bg-purple h-0.5 rounded-l-full"
					style={{
						width: `${percentage}%`,
					}}
				/>
			</div>
			<div
				className={`grid aspect-square w-8 place-items-center rounded-full border-2 ${
					finished ? "border-purple" : "border-charcoal-light"
				}`}
			>
				{finished && <Tick className="stroke-beige w-full" />}
			</div>
		</div>
	);
};

export default ProgressBar;
